<template>
  <div class="container-fluid py-4">
    <div class="row mb-4">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Parc</h4>
        <router-link to="/add-parc">
          <button class="btn text-white" style="background-color: #b03a45;">+ Add to Parc</button>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 mt-n4 mx-3 z-index-2">
            <div class="shadow-success border-radius-lg pt-4 pb-3" style="background: linear-gradient(195deg, #b03a45, #8d2e38);">
              <h6 class="text-white ps-3">Cars Table</h6>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>Car Brand</th>
                    <th>Model</th>
                    <th>Plate Number</th>
                    <th>Type</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(car, index) in parc" :key="index">
                    <td>{{ car.brand }}</td>
                    <td>{{ car.model }}</td>
                    <td>{{ car.plate }}</td>
                    <td>{{ car.type }}</td>
                    <td class="text-center">
                      <router-link :to="`/modifier-parc/${car.id}`" class="text-primary me-3">
                        <i class="fas fa-edit"></i>
                      </router-link>
                      <a href="javascript:;" class="text-danger" @click="deleteCar(car.id)">
                        <i class="fas fa-trash-alt"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="parc.length === 0" class="text-center py-4 text-muted">No cars to show.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "parc",
  data() {
    return {
      parc: [
        { id: 1, brand: "Peugeot", model: "208", plate: "123-TUN-456", type: "Compact" },
        { id: 2, brand: "Renault", model: "Clio", plate: "789-TUN-101", type: "Hatchback" }
      ]
    };
  },
  methods: {
    deleteCar(id) {
      this.parc = this.parc.filter(c => c.id !== id);
      alert("Car deleted.");
    }
  }
};
</script>
